/** SVG Shape Enum
    @readonly
    @enum {string}
*/
export var SVGELEMENT;
(function (SVGELEMENT) {
    SVGELEMENT["SVG"] = "svg";
    SVGELEMENT["DEFS"] = "defs";
    SVGELEMENT["CLIPPATH"] = "clipPath";
    SVGELEMENT["SET"] = "set";
    SVGELEMENT["STOP"] = "stop";
    SVGELEMENT["FILTER"] = "filter";
    SVGELEMENT["PATTERN"] = "pattern";
    SVGELEMENT["MASK"] = "mask";
    SVGELEMENT["G"] = "g";
    SVGELEMENT["RADIALGRADIENT"] = "radialGradient";
    SVGELEMENT["LINEARGRADIENT"] = "linearGradient";
    SVGELEMENT["RECT"] = "rect";
    SVGELEMENT["CIRCLE"] = "circle";
    SVGELEMENT["ELLIPSE"] = "ellipse";
    SVGELEMENT["PATH"] = "path";
    SVGELEMENT["POLYGON"] = "polygon";
    SVGELEMENT["POLYLINE"] = "polyline";
    SVGELEMENT["LINE"] = "line";
    SVGELEMENT["TEXT"] = "text";
    SVGELEMENT["TSPAN"] = "tspan";
    SVGELEMENT["TEXTPATH"] = "textPath";
    SVGELEMENT["SYMBOL"] = "symbol";
    SVGELEMENT["IMAGE"] = "image";
})(SVGELEMENT || (SVGELEMENT = {}));
;
